import type { BugReport } from '@aegislab/shared';
import { calculateStalenessPercent } from '@aegislab/shared';
import type { BugReportListItem } from '../model/types';

const STALENESS_THRESHOLD_DAYS = 7;

export function mapBugReportToListItem(
  bugReport: BugReport,
  reporterName: string,
  assigneeName: string | null
): BugReportListItem {
  return {
    id: bugReport.id,
    reportNumber: bugReport.reportNumber,
    content: bugReport.content,
    type: bugReport.type,
    status: bugReport.status,
    reporterName,
    assigneeName,
    affectedCount: bugReport.affectedUserIds.length,
    attachmentCount: bugReport.attachments.length,
    stalenessPercent: calculateStalenessPercent(bugReport.lastActivityAt, STALENESS_THRESHOLD_DAYS),
    createdAt: bugReport.createdAt,
    lastActivityAt: bugReport.lastActivityAt,
  };
}

export function mapBugReportsToListItems(
  bugReports: BugReport[],
  nameMap: Map<string, string>
): BugReportListItem[] {
  return bugReports.map((br) =>
    mapBugReportToListItem(
      br,
      nameMap.get(br.reporterId) ?? 'Unknown',
      br.assigneeId ? (nameMap.get(br.assigneeId) ?? null) : null
    )
  );
}
